import React from 'react';

import { setApp, getApp} from '../../index';

class SelectField extends React.Component {
    constructor(props) {
        super(props);
        var thisName = this.props.name;
        var existingValue = getApp(thisName);
        var existingLabel = getApp(thisName + "_label");
        this.state = { 
            adjuster: existingLabel ? existingLabel: this.props.placeholder,
            value: existingValue ? existingValue: ""
        };
    }

    handleChange(event) {
        var newVal = event.target.value;
        var newName = this.props.name;
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]
        var optionLabel =  optionElement.getAttribute('label');
        setApp(newName, newVal);
        setApp(newName + "_label", optionLabel);

        this.setState({
            adjuster: optionLabel ? optionLabel : this.props.placeholder,
            value: newVal,
        });

        if (this.props.handleChange !== null)
            this.props.handleChange(newVal);
        // console.log("State after selected field changed: Adjuster - " + this.state.adjuster + ", value - " + this.state.value);
    }

    render() {
        var theOptions = this.props.options.map(function (option) {
            return(<option key={option.name} value={option.value} label={option.name}>{option.name}</option>);
        });
        if(this.props.required === true) {
            var adjusterClass = "select-adjuster required";
        }else{
            var adjusterClass = "select-adjuster";
        }
        return (
            <div>               
                <label htmlFor={this.props.name} className={`${this.props.labelType}-label`}>{this.props.label ? this.props.label : this.props.placeholder}</label>
                <div className={`loanApp-select-field hug ${this.props.required}`}>                 
                    <select name={this.props.name} onChange={this.handleChange.bind(this)} value={this.state.value} required={this.props.required}>
                        <option value="">{this.props.placeholder}</option>
                        {theOptions}
                    </select>
                    <div className={adjusterClass}>{this.state.adjuster}</div>
                </div>
            </div>
        )
    }
}

SelectField.defaultProps = {
    handleChange: null
};

export default SelectField;